import React from 'react';
import { AlertCircle } from 'lucide-react';

interface FieldErrorProps {
  id: string;
  message: string;
}

export const FieldError: React.FC<FieldErrorProps> = ({ id, message }) => (
  <span id={id} role="alert" className="flex max-w-[260px] items-start gap-1 text-[12.5px] leading-snug text-theme-text-primary">
    <AlertCircle className="mt-px h-3.5 w-3.5 shrink-0 text-theme-accent-error" aria-hidden="true" />
    <span dir="auto">{message}</span>
  </span>
);
